export const EmploymentStatusEnum = Object.freeze({
  EMPLOYED: 'EMPLOYED',
  RETIRED: 'RETIRED',
  STUDENT: 'STUDENT',
  UNEMPLOYED: 'UNEMPLOYED',
  SELF_EMPLOYED: 'SELF_EMPLOYED',
})
